export const experiences = [
  /*
  {
    id: 1,
    position: "Frontend Developer",
    company: "Tech Solutions Inc.",
    date: "2021 - Present",
    description: "Developed and maintained responsive web applications using React.js. Collaborated with designers and backend developers to implement new features.",
    skills: ["React", "Redux", "TypeScript", "CSS"]
  },
  {
    id: 2,
    position: "Junior Web Developer",
    company: "Digital Agency",
    date: "2019 - 2021",
    description: "Built client websites using HTML, CSS, and JavaScript. Assisted in the development of WordPress themes and plugins.",
    skills: ["HTML", "CSS", "JavaScript", "WordPress"]
  },
  {
    id: 3,
    position: "Web Development Intern",
    company: "StartUp Co.",
    date: "2018 - 2019",
    description: "Learned web development fundamentals and contributed to small projects. Assisted in debugging and testing web applications.",
    skills: ["HTML", "CSS", "JavaScript"]
  }*/
];